import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { ZustandStorageKeys } from '~/constants/zustandStorageKeys';
import {
  createDismissedCreditUsageAlertSlice,
  type DismissedCreditUsageAlertSlice,
} from '~/hooks/creditUsageAlerts/createDismissedCreditUsageAlertSlice';

export const useDismissedCreditUsageAlertSessionStorageStore = create<DismissedCreditUsageAlertSlice>()(
  persist(
    (...args) => ({
      ...createDismissedCreditUsageAlertSlice()(...args),
    }),
    {
      name: ZustandStorageKeys.CreditUsageDismissedAlertsSession,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
